function ErrorIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 49 49"
      fill="#EE8781"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24.5 0C10.976 0 0 10.976 0 24.5S10.976 49 24.5 49 49 38.024 49 24.5 38.024 0 24.5 0zm2.45 36.75h-4.9v-4.9h4.9v4.9zm0-9.8h-4.9v-14.7h4.9v14.7z" />
    </svg>
  )
}

export default ErrorIcon
